<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>我要考试</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col :span="24">
      <el-table
        :data="exams" border  highlight-current-row v-loading="loading"
        style="width: 100%">
        <el-table-column
          prop="testName"
          label="标题" width="600" align="center">
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="考试开始日期" align="center">
        </el-table-column>
        <el-table-column
          prop="updateDate"
          label="考试结束日期" align="center">
        </el-table-column>
        <el-table-column
          prop="examId"
          label="已考/未考"
          :formatter="formatter.examFormatter" align="center">
        </el-table-column>
        <el-table-column
          prop="submitDate"
          label="考试时间"
          :formatter="formatter.examDateFormatter" align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="操作" width="120"  fixed="right" align="center">
            <template slot-scope="scope">
              <el-button v-if="!scope.row.examId" type="text" size="mini" @click="userExam(scope.$index,scope.row)">考试</el-button>
            </template>
        </el-table-column>
      </el-table>
    </el-col >
    <el-col :span="24">
      <ExamVue ref="childExamDom" @childCallback="childCallback"></ExamVue>
    </el-col>
  </el-row>
</template>

<script>
import util from '../../common/util';
import API from '../../api/api_dashboard';
import examvue  from './exam';
export default {
  data(){
    return{
      formatter:{
        examFormatter:function (row, column){
          if(row.examId){
            return "已考";
          }else{
            return "未考";
          }
        },
        examDateFormatter:function (row, column){
          if(row.examId){
            return row.submitDate;
          }
          else{
            return "";
          }
        }
      },
      exams:[],
      loading:false,
    }
  },
  methods:{
    search:function(){
      let that =this;
      let params={}
      API.getCanExamList(params)
        .then(
            function (result) {
              that.loading = false;
              if (result && result.code == 200) {
                  if(result.data )
                  {
                      that.exams=result.data;
                  }
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
              });
            }
        )
        .catch(function (error) {
            that.loading = false;
            that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
            });
        });
    },
    userExam:function(index,row){
      let that =this;
      that.$refs["childExamDom"].examFormVisible=true;
      that.$refs["childExamDom"].rateId=row.rateId;
      that.$refs["childExamDom"].search(row.testId,index);
      that.$refs["childExamDom"].handleSubmit=function(){
        that.$refs["childExamDom"].submit();
      }
    },
    //子页面相符页面传值
    childCallback:function(msg){
      let that = this;
      console.log(msg);
      that.search();
      //that.exams.splice(msg,1);
    }
  },
  mounted() {
      this.search();
  },
  components: {
    'ExamVue': examvue  //
  }

}
</script>


// WEBPACK FOOTER //
// wantExam.vue?4189c8bb